export default __webpack_public_path__ + "8a5727d18953ffffd61db345cf3ed197.jpg";